/* FOOLSGOLD – Immersive layer behaviour (no dependencies) */
(() => {
  if (window.__fgImmersive) return; window.__fgImmersive = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- Cart helpers ---------- */
  async function addToCart(id, qty = 1) {
    const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const sections = cartEl && typeof cartEl.getSectionsToRender === 'function'
      ? cartEl.getSectionsToRender().map((s) => s.id) : ['cart-icon-bubble'];
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }], sections, sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to bag');
    // Let Dawn/Rise's own cart UI render (drawer or notification)
    try {
      if (cartEl && typeof cartEl.renderContents === 'function') {
        const item = Object.assign({}, data.items ? data.items[0] : data, { sections: data.sections, id: data.items ? data.items[0].id : data.id, key: data.items ? data.items[0].key : data.key });
        if (cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
        cartEl.renderContents(item);
      } else if (data.sections && data.sections['cart-icon-bubble']) {
        const bubble = document.getElementById('cart-icon-bubble');
        const html = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (bubble && html) bubble.innerHTML = html.innerHTML;
      }
    } catch (e) { /* UI refresh is best-effort */ }
    if (window.publish && window.PUB_SUB_EVENTS) window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'fg-immersive' });
    return data;
  }

  function bindAddForms(scope = document) {
    scope.querySelectorAll('form[data-fg-add]:not([data-bound])').forEach((form) => {
      form.dataset.bound = '1';
      form.addEventListener('submit', (e) => handleAdd(e, form));
    });
  }
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.matches && form.matches('form[data-fg-add]') && !form.dataset.bound) handleAdd(e, form);
  });
  async function handleAdd(e, form) {
        e.preventDefault();
        const btn = (e.submitter && e.submitter.matches('button')) ? e.submitter : form.querySelector('button[type="submit"]');
        const msg = form.querySelector('.fg-card__msg');
        let fd; try { fd = new FormData(form, e.submitter); } catch (_) { fd = new FormData(form); if (e.submitter && e.submitter.name) fd.set(e.submitter.name, e.submitter.value); }
        const id = fd.get('id');
        if (!id) { if (msg) msg.textContent = 'Please choose a size'; return; }
        const label = btn.textContent;
        const small = label.trim().length <= 4;
        btn.disabled = true; btn.textContent = small ? '…' : 'Adding…';
        try {
          await addToCart(id);
          btn.textContent = small ? '✓' : 'Added ✓';
          if (msg) msg.innerHTML = '<a href="' + root + 'cart">View bag</a>';
          setTimeout(() => { btn.textContent = label; btn.disabled = false; }, 1800);
        } catch (err) {
          btn.textContent = label; btn.disabled = false;
          if (msg) msg.textContent = err.message;
        }
  }

  /* ---------- Hero ---------- */
  function initHero(hero) {
    if (hero.dataset.ready) return; hero.dataset.ready = '1';
    const toggle = hero.querySelector('[data-fg-hero-toggle]');
    hero.querySelectorAll('video').forEach((v) => {
      const visible = getComputedStyle(v).display !== 'none';
      if (visible && !reduce) { v.preload = 'auto'; v.autoplay = true; v.play().catch(() => {}); }
      else { v.removeAttribute('autoplay'); v.pause(); }
    });
    const videos = () => [...hero.querySelectorAll('video')];
    if (toggle) toggle.addEventListener('click', () => {
      const paused = toggle.getAttribute('aria-pressed') === 'true';
      videos().forEach((v) => (paused ? v.play() : v.pause()));
      toggle.setAttribute('aria-pressed', String(!paused));
      toggle.setAttribute('aria-label', paused ? 'Pause background video' : 'Play background video');
    });
    // Pause offscreen to save battery/CPU
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        if (toggle && toggle.getAttribute('aria-pressed') === 'true') return;
        videos().forEach((v) => { if (getComputedStyle(v).display === 'none') return; en.isIntersecting ? v.play().catch(() => {}) : v.pause(); });
      }, { threshold: 0.05 }).observe(hero);
    }
    if (reduce) { videos().forEach((v) => v.pause()); return; }
    // Scroll: parallax media + fade content
    const media = hero.querySelector('[data-fg-hero-media]');
    const content = hero.querySelector('[data-fg-hero-content]');
    let ticking = false;
    const onScroll = () => {
      if (ticking) return; ticking = true;
      requestAnimationFrame(() => {
        const h = hero.offsetHeight; const y = Math.min(Math.max(window.scrollY - hero.offsetTop, 0), h);
        const p = y / h;
        if (media) media.style.transform = `translate3d(0, ${y * 0.35}px, 0) scale(${1 + p * 0.08})`;
        if (content) { content.style.opacity = String(1 - p * 1.4); content.style.transform = `translate3d(0, ${y * -0.15}px, 0)`; }
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Lookbook ---------- */
  function initLookbook(lb) {
    if (lb.dataset.ready) return; lb.dataset.ready = '1';
    const track = lb.querySelector('[data-fg-track]');
    const looks = [...lb.querySelectorAll('[data-fg-look]')];
    const cur = lb.querySelector('[data-fg-current]');
    const step = () => (looks[0] ? looks[0].getBoundingClientRect().width + 16 : track.clientWidth);
    lb.querySelector('[data-fg-prev]')?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    lb.querySelector('[data-fg-next]')?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', () => {
      const i = Math.round(track.scrollLeft / step()) + 1;
      if (cur) cur.textContent = String(Math.min(i, looks.length)).padStart(2, '0');
    }, { passive: true });

    const closeAll = (except) => lb.querySelectorAll('[data-fg-spot][aria-expanded="true"]').forEach((b) => {
      if (b === except) return; b.setAttribute('aria-expanded', 'false'); document.getElementById(b.getAttribute('aria-controls')).hidden = true;
    });
    lb.querySelectorAll('[data-fg-spot]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const card = document.getElementById(btn.getAttribute('aria-controls'));
        const open = btn.getAttribute('aria-expanded') === 'true';
        closeAll(btn);
        btn.setAttribute('aria-expanded', String(!open)); card.hidden = open;
        if (!open) card.querySelector('input:checked, input:not([disabled]), button')?.focus({ preventScroll: true });
      });
    });
    lb.addEventListener('click', (e) => { if (!e.target.closest('.fg-card')) closeAll(); });
    lb.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
    bindAddForms(lb);
  }

  /* ---------- Sticky add to bag ---------- */
  function initSticky(bar) {
    if (bar.dataset.ready) return; bar.dataset.ready = '1';
    const target = document.querySelector('.product-form__buttons') || document.querySelector('product-form') || document.querySelector('.product__info-container');
    const show = (v) => { bar.classList.toggle('is-visible', v); bar.setAttribute('aria-hidden', String(!v)); };
    const foot = document.querySelector('.footer, footer');
    if (foot && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => bar.classList.toggle('is-hidden-footer', en.isIntersecting), { threshold: 0 }).observe(foot);
    }
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => show(!en.isIntersecting && en.boundingClientRect.top < 0), { threshold: 0 }).observe(target);
    }
    const select = bar.querySelector('[data-fg-sticky-select]');
    const price = bar.querySelector('[data-fg-sticky-price]');
    const sync = (id) => {
      if (!select || !id) return;
      const opt = select.querySelector(`option[value="${id}"]`);
      if (opt) { select.value = id; if (price && opt.dataset.price) price.innerHTML = opt.dataset.price; }
    };
    select?.addEventListener('change', () => {
      sync(select.value);
      // keep main page in step via URL param
      const mainId = document.querySelector('product-form form input[name="id"], form[action*="/cart/add"] input[name="id"]');
      if (mainId && mainId.value !== select.value) { const u = new URL(location.href); u.searchParams.set('variant', select.value); history.replaceState({}, '', u); }
    });
    // Follow variant changes from the main picker
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      window.subscribe(PUB_SUB_EVENTS.variantChange, (e) => { const v = e.data && e.data.variant; if (v) sync(String(v.id)); });
    }
    document.addEventListener('change', (e) => { if (e.target.matches('product-form input[name="id"], form[action*="/cart/add"] input[name="id"]')) sync(e.target.value); });
    const url = new URL(location.href).searchParams.get('variant'); if (url) sync(url);
    bindAddForms(bar);
  }

  /* ---------- Transparent header over hero (homepage) ---------- */
  function setChrome() {
    const h = document.querySelector('.section-header'); const a = document.querySelector('.announcement-bar-section, .utility-bar');
    const v = (h ? h.offsetHeight : 0) + (a ? a.offsetHeight : 0);
    document.documentElement.style.setProperty('--fg-chrome-h', v + 'px');
  }
  setChrome(); window.addEventListener('resize', setChrome);
  function initHeaderOverlay() {
    const body = document.body;
    const main = document.querySelector('#MainContent');
    const firstHero = main && main.querySelector('.shopify-section:first-child .fg-hero[data-fg-overlay-header]');
    const header = document.querySelector('.section-header');
    if (!firstHero || !header) { body.classList.remove('fg-header-overlay', 'fg-header-clear'); return; }
    body.classList.add('fg-header-overlay');
    firstHero.closest('.shopify-section').classList.add('fg-hero-section');
    const setH = () => document.documentElement.style.setProperty('--fg-header-h', header.offsetHeight + 'px');
    setH(); window.addEventListener('resize', setH);
    const upd = () => body.classList.toggle('fg-header-clear', window.scrollY < Math.max(40, firstHero.offsetHeight - header.offsetHeight - 40));
    upd(); window.addEventListener('scroll', upd, { passive: true });
  }

  /* ---------- Campaign tile videos: play only when visible ---------- */
  function initTiles(scope = document) {
    const vids = [...scope.querySelectorAll('.fg-tile__video')].filter((v) => !v.dataset.fgBound);
    if (!vids.length) return;
    const tryPlay = (v) => { if (reduce || !v._vis) return; const p = v.play(); if (p && p.catch) p.catch(() => {}); };
    const io = 'IntersectionObserver' in window ? new IntersectionObserver((ens) => ens.forEach((en) => {
      const v = en.target; v._vis = en.isIntersecting;
      if (en.isIntersecting) tryPlay(v); else v.pause();
    }), { threshold: 0.15 }) : null;
    vids.forEach((v) => {
      v.dataset.fgBound = '1'; v.muted = true; v._vis = !io;
      v.addEventListener('canplay', () => tryPlay(v));
      v.addEventListener('pause', () => { if (v._vis) setTimeout(() => tryPlay(v), 300); });
      if (io) io.observe(v); else tryPlay(v);
    });
  }

  /* ---------- Product rail ---------- */
  function initRail(r) {
    if (r.dataset.ready) return; r.dataset.ready = '1';
    const t = r.querySelector('[data-fg-rail-track]');
    const step = () => { const c = t.querySelector('.fg-pcard'); return c ? (c.getBoundingClientRect().width + 2) * 2 : t.clientWidth * 0.8; };
    r.querySelector('[data-fg-rail-prev]')?.addEventListener('click', () => t.scrollBy({ left: -step(), behavior: 'smooth' }));
    r.querySelector('[data-fg-rail-next]')?.addEventListener('click', () => t.scrollBy({ left: step(), behavior: 'smooth' }));
    bindAddForms(r);
  }
  /* ---------- Reveal ---------- */
  function initReveal(scope = document) {
    const els = scope.querySelectorAll('[data-fg-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((ens) => ens.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { threshold: 0.2 });
    els.forEach((e) => io.observe(e));
  }


  /* ---------- Collection page ---------- */
  function initColl(c) {
    if (c.dataset.ready) return; c.dataset.ready = '1';
    const grid = c.querySelector('[data-fg-grid]');
    bindAddForms(c);
    // keep the active collection chip in view
    const chips = c.querySelector('.fg-coll__chips'), act = chips?.querySelector('.fg-cchip.is-active');
    if (chips && act) chips.scrollLeft = Math.max(0, act.getBoundingClientRect().left - chips.getBoundingClientRect().left + chips.scrollLeft - (chips.clientWidth - act.offsetWidth) / 2);
    // sort
    c.querySelector('[data-fg-sort]')?.addEventListener('change', (e) => {
      const u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page'); location.href = u.toString();
    });
    // density
    const btns = c.querySelectorAll('[data-fg-density]');
    const setD = (d) => { if (!grid) return; grid.dataset.density = d; btns.forEach((b) => b.classList.toggle('is-active', b.dataset.fgDensity === d)); try { localStorage.setItem('fgDensity', d); } catch (_) {} };
    let saved = '4'; try { saved = localStorage.getItem('fgDensity') || '4'; } catch (_) {}
    setD(saved);
    btns.forEach((b) => b.addEventListener('click', () => setD(b.dataset.fgDensity)));
    // load more
    const more = c.querySelector('[data-fg-more]');
    more?.addEventListener('click', async (e) => {
      e.preventDefault(); if (more.dataset.busy) return; more.dataset.busy = '1'; const label = more.textContent; more.textContent = 'Loading…';
      try {
        const html = await (await fetch(more.href)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const items = doc.querySelectorAll('[data-fg-grid] > .fg-cgrid__item');
        items.forEach((it, i) => { it.style.animationDelay = (i % 8) * 40 + 'ms'; grid.appendChild(document.importNode(it, true)); });
        bindAddForms(grid);
        const nextMore = doc.querySelector('[data-fg-more]');
        const prog = c.querySelector('[data-fg-progress]'); const nprog = doc.querySelector('[data-fg-progress]');
        if (nextMore) { more.href = nextMore.href; more.textContent = label; if (prog && nprog) prog.textContent = nprog.textContent; }
        else { c.querySelector('.fg-coll__more')?.remove(); }
        history.replaceState(null, '', location.pathname + location.search);
      } catch (_) { location.href = more.href; }
      delete more.dataset.busy;
    });
    // keep the toolbar below the sticky header when it is showing
    const bar = c.querySelector('[data-fg-coll-bar]');
    const hdr = document.querySelector('.section-header');
    if (bar && hdr) {
      const upd = () => {
        const shown = hdr.classList.contains('shopify-section-header-sticky') && !hdr.classList.contains('shopify-section-header-hidden');
        bar.style.setProperty('--fg-bar-top', shown ? hdr.getBoundingClientRect().height + 'px' : '0px');
      };
      new MutationObserver(upd).observe(hdr, { attributes: true, attributeFilter: ['class'] });
      window.addEventListener('scroll', upd, { passive: true }); upd();
    }
  }


  /* ---------- Size chart units ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('[data-fg-unit]'); if (!b) return;
    const box = b.closest('[data-fg-size]'); const u = b.dataset.fgUnit;
    box.querySelectorAll('[data-fg-unit]').forEach((x) => { const on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', String(on)); });
    box.querySelectorAll('[data-cm]').forEach((x) => { x.hidden = u !== 'cm'; });
    box.querySelectorAll('[data-in]').forEach((x) => { x.hidden = u !== 'in'; });
  });

  function init(scope = document) {
    scope.querySelectorAll('[data-fg-rail]').forEach(initRail);
    initReveal(scope);
    if (scope === document) initHeaderOverlay();
    initTiles(scope);
    scope.querySelectorAll('[data-fg-hero]').forEach(initHero);
    scope.querySelectorAll('[data-fg-lookbook]').forEach(initLookbook);
    scope.querySelectorAll('[data-fg-sticky]').forEach(initSticky);
    scope.querySelectorAll('[data-fg-coll]').forEach(initColl);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (e) => { init(e.target); initHeaderOverlay(); });
  document.addEventListener('shopify:section:reorder', initHeaderOverlay);
})();
